import React, { Component } from "react";
import warn from "../../static/images/warn.png";
import styles from "./index.less";

interface Props {
  errorTip: string;
}
class ErrorTip extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }
  render() {
    const { errorTip } = this.props;
    return (
      <div className={styles.errorTip}>
        <img src={warn} />
        <span>{errorTip}</span>
      </div>
    );
  }
}

export default ErrorTip;
